import { Component } from 'react'
import { featureRouteFilter } from '../../lib/renderUtil'
import { ConnectedRouter } from 'connected-react-router'
import Layout from './Layout'

import { history } from '../configureStore'

class App extends Component {
  render () {
    const { flags, page = {} } = this.props
    const routes = featureRouteFilter(flags)
    return (
      <>
        <ConnectedRouter history={history}>
          <Layout
            routes={routes}
            isSeller={page.isSeller}
          />
        </ConnectedRouter>
      </>
    )
  }
}

export default App
